// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"c335fe1c","179":"49f13d41","228":"9a8d47dc","272":"8ec62dfe","352":"b87ca66d","549":"754ac649","666":"b2c655b9","816":"b8dffc6e","930":"5b398b50","996":"1b81ca9e"}[chunkId] + ".chunk.js";
};